import AppSwiper from "../../../components/common/AppSwiper/AppSwiper";
import ArticleCard from "../ArticleCard/ArticleCard";

export default function RelatedArticles({
    articles = [],
}) {
    if (!articles.length) {
        return null;
    }

    return (
        <section className="article-related-section">

            <div className="article-related-section__header">

                <div>
                    <span className="article-related-section__eyebrow">
                        مطالعه بیشتر
                    </span>

                    <h2>
                        مقالات مرتبط
                    </h2>
                </div>

            </div>


            <AppSwiper
                slidesPerView={5}
                spaceBetween={16}
                navigation={false}
                pagination={false}
                loop={false}
                  breakpoints={{
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 12,
                    },

                    576: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                    },

                    992: {
                        slidesPerView: 4,
                        spaceBetween: 20,
                    },

                    1200: {
                        slidesPerView: 5,
                        spaceBetween: 16,
                    },
                }}
                className="article-related-swiper"
            >

                {articles.map(article => (
                    <ArticleCard
                        key={article.id}
                        article={article}
                    />
                ))}

            </AppSwiper>

        </section>
    );
}